/**
 * Normalises an inputted path to be compatible with any base URL.
 * @param path Path to normalise
 * @returns Normalised path
 */
export const normalisePath = (path: string): string => isRelative(path) ? path.replace(/^(\.?\/)?/, './').replace(/(\.\/.*)\/$/, '$1') : path;

/**
 * Check to see whether a URL is absolute or not.
 * @param url URL to check
 * @returns True if the URL is absolute
 */
export const isAbsolute = (url: string): boolean => (/^[a-z]+\:\/{2}.+/i).test(url);

/**
 * Checks to see whether a URL is a mailto link or not.
 * @param url URL to check
 * @returns True if the URL is a mailto link
 */
export const isMailTo = (url: string): boolean => (/^mailto\:.+/i).test(url);

/**
 * Checks to see whether a URL is relative or not.
 * @param url URL to check
 * @returns True if the URL is relative
 */
export const isRelative = (url: string): boolean => !isAbsolute(url) && !isMailTo(url);
